<template>
  <div>
    <div class="contain">
      <div class="card card-1" :class="{ active: currentCard === 1, hidden: currentCard !== 1 }">
        <a class="login">Book Date</a>
        <div class="inputBox">
          <input type="text" v-model="additionalInfo" required="required">
          <span class="user">Additional info</span>
        </div>
        <v-container class="date">
          <v-card class="datee">
            <v-toolbar
                dense
                flat
                class="body-2 font-weight-bold"
                color="grey lighten-2"
            >
              Book your days here
            </v-toolbar>

            <!-- First Date Picker -->
            <v-menu
                v-model="fromDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="300px"
                min-width="250px"
                class="info"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    label="Installation date"
                    prepend-icon="mdi-calendar"
                    readonly
                    :value="fromDateDisp"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  locale="en-in"
                  v-model="fromDateVal"
                  no-title
                  @input="fromDateMenu = false"
                  :allowed-dates="allowedFirstDate"
              ></v-date-picker>
            </v-menu>

            <!-- Second Date Picker -->
            <v-menu
                v-model="secondDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="300px"
                min-width="250px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                    label="Pick your go live date"
                    prepend-icon="mdi-calendar"
                    readonly
                    :value="secondDateDisp"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  locale="en-in"
                  v-model="secondDateVal"
                  no-title
                  @input="fromDateMenu = false"
                  :allowed-dates="allowedSecondDate"
              ></v-date-picker>
            </v-menu>
          </v-card>
        </v-container>
        <button class="next" @click="nextCard">Next</button>
      </div>



      <div class="card card-2" :class="{ active: currentCard === 2, hidden: currentCard !== 2 }">
        <a class="login">Requirements</a>
        <p>Tick the options that will be available on the day of installation</p>

        <div class="line"></div>

        <div class="crd" @click="toggleCheckbox('electricity')">
          <div class="card-details">
            <label class="custom-checkbox" for="cb-47-1">
              <input v-model="electricity" name="cb" id="cb-47-1" type="checkbox">
              <span class="checkmark"></span>
            </label>
            <p class="text-title">Electricity</p>
          </div>
          <button class="card-button">Select</button>
        </div>


        <div class="crd" @click="toggleCheckbox('internet')">
          <div class="card-details">
            <label class="custom-checkbox" for="cb-47-2">
              <input v-model="internet" name="cb" id="cb-47-2" type="checkbox">
              <span class="checkmark"></span>
            </label>
            <p class="text-title">Internet</p>
          </div>
          <button class="card-button">Select</button>
        </div>

        <div class="crd" @click="toggleCheckbox('hardware')">
          <div class="card-details">
            <label class="custom-checkbox" for="cb-47-3">
              <input v-model="hardware" name="cb" id="cb-47-3" type="checkbox">
              <span class="checkmark"></span>
            </label>
            <p class="text-title">Hardware</p>
          </div>
          <button class="card-button">Select</button>
        </div>

        <div style="display: flex; justify-content: center">
          <button class="next" @click="nextCard">Next</button>
        </div>
      </div>



      <div class="card card-2" :class="{ active: currentCard === 3, hidden: currentCard !== 3 }">
        <a class="login">Requirements</a>
        <p>Tick and upload excel files if applicable. </p>

        <div class="line"></div>
        <div class="crd" @click="toggleCheckbox('stockList')">
          <div class="card-details">
            <label class="custom-checkbox" for="cb-47-4">
              <input v-model="stockLists" name="cb" id="cb-47-4" type="checkbox">
              <span class="checkmark"></span>
            </label>
            <button class="container-btn-file">
              <svg
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 50"
              >
                <path
                    d="M28.8125 .03125L.8125 5.34375C.339844
    5.433594 0 5.863281 0 6.34375L0 43.65625C0
    44.136719 .339844 44.566406 .8125 44.65625L28.8125
    49.96875C28.875 49.980469 28.9375 50 29 50C29.230469
    50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844
    30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625
    .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32
    6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34
    29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49
    43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44
    13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938
    21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219
    22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375
    15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125
    28.28125C15.160156 28.054688 15.035156 27.636719 14.90625
    27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719
    14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36
    20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z"
                ></path>
              </svg>
               Stock-list File
              <input @change="handleFileChange('stockList', $event)" class="file" name="text" type="file" />
            </button>
          </div>
          <button class="card-button">Select</button>
        </div>

        <div class="crd" @click="toggleCheckbox('requiredStaff')">
          <div class="card-details">
            <label class="custom-checkbox" for="cb-47-5">
              <input v-model="requiredStaff" name="cb" id="cb-47-5" type="checkbox">
              <span class="checkmark"></span>
            </label>
            <button class="container-btn-file">
              <svg
                  fill="#fff"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 50"
              >
                <path
                    d="M28.8125 .03125L.8125 5.34375C.339844
    5.433594 0 5.863281 0 6.34375L0 43.65625C0
    44.136719 .339844 44.566406 .8125 44.65625L28.8125
    49.96875C28.875 49.980469 28.9375 50 29 50C29.230469
    50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844
    30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625
    .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32
    6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34
    29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49
    43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44
    13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938
    21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219
    22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375
    15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125
    28.28125C15.160156 28.054688 15.035156 27.636719 14.90625
    27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719
    14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36
    20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z"
                ></path>
              </svg>
              Staff-list File
              <input @change="handleFileChange('employeeList', $event)" class="file" name="text" type="file" id="file-input"/>
            </button>
          </div>
          <button class="card-button">Select</button>
        </div>

        <div class="crd">
          <div class="card-details">
            <a href="https://chrilantech.com/download/files/stockTemplates/stockTemplate.xlsx" target="_blank" style="text-decoration: none; color: inherit;">
              <button class="Btnn">
                <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
                <span class="icon2"></span>
                <span class="tooltipp">Stock-list</span>
              </button>
            </a>

            <a href="" target="_blank" style="text-decoration: none; color: inherit;">
              <button class="Btnn" style="margin-left: 100px">
                <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
                <span class="icon2"></span>
                <span class="tooltipp">Staff-list</span>
              </button>
            </a>

          </div>
          <button class="card-button" style="width: 100%; padding: 2px">Download our templates</button>
        </div>


        <div style="display: flex; justify-content: center">
          <button class="next" @click="nextCard">Next</button>
        </div>
      </div>


      <!--this is where card 3 starts, its using the second card's css properties-->
      <div class="card card-2" :class="{ active: currentCard === 4, hidden: currentCard !== 4 }">
        <a class="login">Confirm</a>

        <p v-if="fromDateVal" class="see">Installation Date: {{ fromDateVal }}</p>
        <p v-if="secondDateVal" class="see">Go Live Date: {{ secondDateVal }}</p>
        <!--<p class="see">Additional Info: {{ additionalInfo }}</p>-->
        <p class="see">Electricity: {{ electricity ? 'Yes' : 'No' }}</p>
        <p class="see">Internet: {{ internet ? 'Yes' : 'No' }}</p>
        <p class="see">Hardware: {{ hardware ? 'Yes' : 'No' }}</p>
        <p class="see">Stock List: {{ stockList ? 'Yes' : 'No' }}</p>
        <p class="see">Required Staff: {{ requiredStaff ? 'Yes' : 'No' }}</p>

        <div style="display: flex; justify-content: center">
          <button class="next" @click="nextCard">Confirm</button>
          <!--<button class="next" @click="goHome">Go back and start over</button>-->
        </div>
      </div>



      <div class="card card-4" :class="{ active: currentCard === 5, hidden: currentCard !== 5 }">
        <a class="login">Submit</a>
        <div class="inputBox">
          <input type="text" required="required">
          <span class="comments">Additional Comments</span>
        </div>
        <button class="next" @click="showPopup">Submit</button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';
import axios from 'axios';
export default {
  name: 'HomeApp',

  data() {
    return {
      formData: new FormData(),
      currentCard: 1,
      menu: false,
      due: null, // Date in YYYY-MM-DD format.
      fromDateMenu: false,
      fromDateVal: "",
      secondDateMenu: false,
      secondDateVal: "",
      minDate: new Date().toISOString().substr(0, 10),
      bookedDates: null, //  Booked dates by other customers
      isChecked: false,
      additionalInfo: '',
      additionalComments: '',
      electricity: false,
      internet: false,
      hardware: false,
      stockLists: false,
      requiredStaff: false,
      stockList: '',
      employeeList: '',
      invoiceNumber: ''
    };
  },

  created() {
    this.invoiceNumber = this.$route.query.invoice;
    const check = this.invoiceNumber;

    if (check) {
      // Proceed with the desired action
      console.log("Invoice Number:", check);
      // You can also store it in the component's data or perform any other action

      // Fetch booked dates from the backend
      this.fetchBookedDates();
    } else {

      // Redirect the user to the error page if the invoice number is not available
      this.$router.push('/error');

      /*this.$swal({
        title: 'No invoice number detected',
        text: 'Please contact customer care.',
        icon: 'error',
        confirmButtonText: 'OK'
      })*/
    }
    // this is only here for testing, it should be in the if statement only!
    //this.fetchBookedDates();
  },



  computed: {
    formattedDate() {
      if (!this.due) return '';
      // Format date for display (e.g., MM/DD/YYYY)
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return new Date(this.due).toLocaleDateString(undefined, options);
    },

    fromDateDisp() {
      return this.fromDateVal;
    },
    secondDateDisp() {
      return this.secondDateVal;
    },
    today() {
      const today = new Date();
      return today.toISOString().substr(0, 10);
    }
  },

  methods: {
    toggleCheckbox(propertyName) {
      this[propertyName] = !this[propertyName];
    },
    //...mapActions(['setFormData']),

    // Method to fetch booked dates from the backend
    async fetchBookedDates() {
      try {
        const response = await axios.get(synergyApi+`store-setup/store-setup-schedule?invoiceNumber=${this.invoiceNumber}`);
        console.log(response);
        this.bookedDates = response.data; // Assuming the API returns an array of booked dates
        console.log('Booked Dates:', this.bookedDates);

        if (this.bookedDates.length > 0) {
          // Redirect to success page with booked dates
          this.$router.push({ name: 'SuccessPage', query: {invoiceNumber: this.invoiceNumber } });
        }

      } catch (error) {
        console.error('Error fetching booked dates:', error);
        this.$swal({
          title: 'Error',
          text: 'Failed to retrieve booked dates. Please try again later.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    },

    nextCard() {
      this.currentCard = (this.currentCard % 5) + 1;
    },

    allowedFirstDate(date) {
      const isBooked = this.bookedDates.includes(date);
      const isPast = date < this.today;
      const isCurrent = date === this.today;

      return !isBooked && !isPast && !isCurrent;
    },
    allowedSecondDate(date) {
      const isBooked = this.bookedDates.includes(date);
      const isPast = date < this.today;
      const isCurrent = date === this.today;
      const isBeforeFirst = this.fromDateVal && date <= this.fromDateVal;

      return !isBooked && !isPast && !isCurrent && !isBeforeFirst;
    },

    //converting the files the customer uploads to base64
    async handleFileChange(target, event) {
      try {
        const file = event.target.files[0];
        const base64 = await this.getBase64(file);
        this[target] = base64;
      } catch (error) {
        console.error('Error converting file to base64:', error);
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    goHome() {
      window.location.href = 'http://localhost:8080/';
      window.location.reload();
    },

    ...mapActions(['setFormData', 'submitFormData']),
    showPopup() {
      const swalWithVuetifyButtons = Swal.mixin({
        customClass: {
          confirmButton: 'v-btn--is-elevated v-btn--contained theme--light',
          cancelButton: 'v-btn--is-elevated v-btn--contained theme--light',
        },
        buttonsStyling: false
      });

      swalWithVuetifyButtons.fire({
        title: 'Are all your details correct?',
        text: "Please note that any wrong information provided may result in additional charges!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'CONFIRM!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          swalWithVuetifyButtons.fire({
            title: 'Confirmed!',
            text: 'Please proceed to sign.',
            icon: 'success'
          }).then(() => {

            // Constructing the object with all form data
            const formData = {
              invoiceNumber: this.invoiceNumber,
              installationDate: this.fromDateDisp,
              goingLiveDate: this.secondDateDisp,
              additionalNotes: this.additionalInfo,
              power: this.electricity,
              internet: this.internet,
              hardware: this.hardware,
              //stockList: this.stockList,
              //employeeList: this.requiredStaff,
              stockList: this.stockList,
              employeeList: this.employeeList,
            };

            //localStorage.setItem('formData', JSON.stringify(formData));
            this.setFormData(formData); // Saving data to Vuex
            console.log(formData);
            this.$router.push('/sign'); // Navigate to the sign page after confirming
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithVuetifyButtons.fire({
            title: 'Cancelled',
            text: '',
            icon: 'error'
          }).then(() => {
            location.reload(); // Refresh the page when cancel is clicked
          });
        }
      });
    }
  },

};
</script>

<style>
.contain {
  position: relative;
  height: 500px;
  width: 330px;
}

.card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 510px;
  width: 330px;
  flex-direction: column;
  gap: 35px;
  background: rgba(17, 24, 39, 1); /* Dark background color resembling a black card */
  color: #fff; /* White text for contrast */
  box-shadow: 0 10px 20px black; /* Dark shadow */
  border-radius: 8px;
  position: absolute;
  top: 20px;
  transition: transform 0.5s ease, opacity 0.5s ease;
  opacity: 0;
  z-index: 0;
  transform: scale(0.95);
  padding: 5px;
}

.card.active {
  opacity: 1;
  z-index: 2;
  transform: scale(1);
}

.card.hidden {
  opacity: 0;
  z-index: 0;
  transform: scale(0.95);
}

.card-2 {
  display: block;
  padding: 40px;
}

.login {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  display: block;
  font-weight: bold;
  font-size: x-large;

}

.card-2 .login {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .card {
    height: 630px;
  }
}

.inputBox {
  position: relative;
  width: 250px;
}

.inputBox input {
  width: 100%;
  padding: 10px;
  outline: none;
  border: none;
  color: #fff;
  font-size: 1em;
  background: transparent;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transition: 0.1s;
  border-bottom-left-radius: 8px;
}

.inputBox span {
  margin-top: 5px;
  position: absolute;
  left: 0;
  transform: translateY(-4px);
  margin-left: 10px;
  padding: 10px;
  pointer-events: none;
  font-size: 12px;
  color: #fff;
  text-transform: uppercase;
  transition: 0.5s;
  letter-spacing: 3px;
  border-radius: 8px;
}

.inputBox input:valid~span,
.inputBox input:focus~span {
  transform: translateX(113px) translateY(-15px);
  font-size: 0.8em;
  padding: 5px 10px;
  background: #fff;
  letter-spacing: 0.2em;
  color: #333;
  border: 2px;
}

.inputBox input:valid,
.inputBox input:focus {
  border: 2px solid #fff;
  border-radius: 8px;
}

.next {
  height: 45px;
  width: 100px;
  border-radius: 5px;
  border: 2px solid #fff;
  cursor: pointer;
  background-color: transparent;
  transition: 0.5s;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 2px;
  margin: 3px;
  color: #fff;
}

.next:hover {
  background-color: #fff;
  color: #333;
}

.date {
  width: 270px;
  padding: 10px;
  background: rgb(255, 255, 255);
  border-radius: 2px;
  border: 2px solid black;
  transition: all .2s;
  box-shadow: 12px 12px 2px 1px black;
}

.date:hover {
  box-shadow: -12px 12px 2px -1px black;
}

.datee{
  height: 210px;
  background: rgb(255, 255, 255);
}





.checkbox-wrapper-46 input[type="checkbox"] {
  display: none;
  visibility: hidden;
}

.checkbox-wrapper-46 .cbx {
  margin: auto;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
}
.checkbox-wrapper-46 .cbx span {
  display: inline-block;
  vertical-align: middle;
  transform: translate3d(0, 0, 0);
}
.checkbox-wrapper-46 .cbx span:first-child {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  transform: scale(1);
  vertical-align: middle;
  border: 1px solid #9098a9;
  transition: all 0.2s ease;
}
.checkbox-wrapper-46 .cbx span:first-child svg {
  position: absolute;
  top: 3px;
  left: 2px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 16px;
  stroke-dashoffset: 16px;
  transition: all 0.3s ease;
  transition-delay: 0.1s;
  transform: translate3d(0, 0, 0);
}
.checkbox-wrapper-46 .cbx span:first-child:before {
  content: "";
  width: 100%;
  height: 100%;
  background: #506eec;
  display: block;
  transform: scale(0);
  opacity: 1;
  border-radius: 50%;
}
.checkbox-wrapper-46 .cbx span:last-child {
  padding-left: 8px;
}
.checkbox-wrapper-46 .cbx:hover span:first-child {
  border-color: #506eec;
}

.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child {
  background: #506eec;
  border-color: #506eec;
  animation: wave-46 0.4s ease;
}
.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child svg {
  stroke-dashoffset: 0;
}
.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child:before {
  transform: scale(3.5);
  opacity: 0;
  transition: all 0.6s ease;
}

@keyframes wave-46 {
  50% {
    transform: scale(0.9);
  }
}

.tick {
  font-weight: 400;
  letter-spacing: 1px;
  color: white;
}


.line {
  height: 10px;
  background-color: #0066bb;
  border-radius: 10px;
  margin-top: 20px;
}

#file-input {
  width: 95px;
  max-width: 100%;
  color: #444;
  border-radius: 10px;
  border: 1px solid #007bff;
}
.sec {
  margin-left: 60px;
}

#file-input::file-selector-button {

  border: 1px solid #007bff;
  background-color: #0066bb;

  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  transition: background .2s ease-in-out;
}

#file-input::file-selector-button:hover {
  background: #0d45a5;
}



.checkbox-wrapper-47 input[type="checkbox"] {
  display: none;
  visibility: hidden;
}

.checkbox-wrapper-47 label {
  position: relative;
  padding-left: 2em;
  padding-right: 1em;
  line-height: 2;
  cursor: pointer;
  display: inline-flex;
}

.checkbox-wrapper-47 label:before {
  box-sizing: border-box;
  content: " ";
  position: absolute;
  top: 0.3em;
  left: 0;
  display: block;
  width: 1.4em;
  height: 1.4em;
  border: 2px solid #9098A9;
  border-radius: 6px;
  z-index: -1;
}

.checkbox-wrapper-47 input[type="checkbox"]:checked + label {
  padding-left: 1em;
  color: #0f5229;
}

.checkbox-wrapper-47 input[type="checkbox"]:checked + label:before {
  top: 0;
  width: 100%;
  height: 2em;
  background: #b7e6c9;
  border-color: #2cbc63;
}

.checkbox-wrapper-47 label,
.checkbox-wrapper-47 label::before {
  transition: 0.25s all ease;
}

.files {
  border: 3px solid white;
  padding: 10px; border-radius: 5px;
  margin-bottom: 5px;
  transition: .3s ease;
}

.files:hover {
  transform: translateX(-5%);
  box-shadow: rgba(226, 196, 63, 0.25) 0px 13px 47px -5px, rgba(180, 71, 71, 0.3) 0px 8px 16px -8px;
}

.see {
  width: fit-content;
  height: fit-content;
  padding: 3px;
  background: white;
  border: 2px solid green;
  box-shadow: 12px 17px 51px rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(6px);
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  transition: all 0.7s;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  font-weight: bolder;
  color: black;
}

.see:hover {
  border: 1px solid blue;
  transform: scale(1.07);
}

.see:active {
  transform: scale(0.95) rotateZ(1.7deg);
}


/* Apply more specific styles to buttons */
.swal2-confirm.v-btn--contained {
   /* Vuetify primary color */
  height: 45px;
  width: 100px;
  border-radius: 5px;
  border: 2px solid black;
  cursor: pointer;
  background-color: transparent;
  transition: 0.5s;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 2px;
  margin: 3px;
  color: black;
  font-weight: 400;
}
.swal2-confirm.v-btn--contained:hover {
  background-color: #fff;
  color: #333;
}

.swal2-cancel.v-btn--contained {
  height: 45px;
  width: 100px;
  border-radius: 5px;
  border: 2px solid black;
  cursor: pointer;
  background-color: red;
  transition: 0.5s;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 2px;
  margin: 3px;
  color: white;
}


.crd {
  margin-top: 20px;
  margin-bottom: 30px;
  width: 250px;
  height: 50px;
  border-radius: 5px;
  background: #f5f5f5;
  position: relative;
  padding: 1.8rem;
  border: 2px solid #c3c6ce;
  transition: 0.5s ease-out;
  overflow: visible;
}

.card-details {
  color: black;
  height: 100%;
  display: flex;
  align-items: center;
  gap: .5em;
}
.text-title {
  font-size: 1.5em;
  font-weight: bold;
  margin-top: 15px; /* Ensure no extra margin is added */
  line-height: 1.2; /* Adjust line-height if needed */
}

.card-button {
  transform: translate(-50%, 125%);
  width: 40%;
  border-radius: 1rem;
  border: none;
  background-color: #008bf8;
  color: #fff;
  font-size: 1rem;
  padding: .5rem 1rem;
  position: absolute;
  left: 50%;
  bottom: 0;
  opacity: 0;
  transition: 0.3s ease-out;
}


/*Hover*/
.crd:hover {
  border-color: #008bf8;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
}

.crd:hover .card-button {
  transform: translate(-50%, 50%);
  opacity: 1;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
  color: #333;
  transition: color 0.3s;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 24px;
  height: 24px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 16px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #333;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #fff;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s, transform 0.3s;
}


.container-btn-file {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  background-color: #307750;
  color: #fff;
  border-style: none;
  padding: 7px;
  border-radius: 0.5em;
  overflow: hidden;
  z-index: 1;
  box-shadow: 4px 8px 10px -3px rgba(0, 0, 0, 0.356);
  transition: all 250ms;
}
.container-btn-file input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.container-btn-file > svg {
  margin-right: 1em;
}
.container-btn-file::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 0;
  border-radius: 0.5em;
  background-color: #469b61;
  z-index: -1;
  transition: all 350ms;
}
.container-btn-file:hover::before {
  width: 100%;
}


.Btnn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background-color: rgb(27, 27, 27);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition-duration: .3s;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.11);
}

.svgIcon {
  fill: rgb(214, 178, 255);
}

.icon2 {
  width: 18px;
  height: 5px;
  border-bottom: 2px solid rgb(182, 143, 255);
  border-left: 2px solid rgb(182, 143, 255);
  border-right: 2px solid rgb(182, 143, 255);
}

.tooltipp {
  position: absolute;
  right: -105px;
  opacity: 0;
  background-color: rgb(12, 12, 12);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition-duration: .2s;
  pointer-events: none;
  letter-spacing: 0.5px;
}

.tooltipp::before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: rgb(12, 12, 12);
  background-size: 1000%;
  background-position: center;
  transform: rotate(45deg);
  left: -5%;
  transition-duration: .3s;
}

.Btnn:hover .tooltipp {
  opacity: 1;
  transition-duration: .3s;
}

.Btnn:hover {
  background-color: rgb(150, 94, 255);
  transition-duration: .3s;
}

.Btnn:hover .icon2 {
  border-bottom: 2px solid rgb(235, 235, 235);
  border-left: 2px solid rgb(235, 235, 235);
  border-right: 2px solid rgb(235, 235, 235);
}

.Btnn:hover .svgIcon {
  fill: rgb(255, 255, 255);
  animation: slide-in-top 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

</style>
